module.exports = __webpack_public_path__ + "static/media/cinta.892d40c6.jpg";